import { cn } from '@client/lib';
import {
  formatPercent,
  defaultHealthcareInflation,
  isNullOrUndefined,
} from '@shared';

export function HealthcareInflationCitation({
  client,
  className,
}: {
  client: Client;
  className?: string;
}) {
  const {
    defaultHealthcareInflationPercent,
    defaultHealthcareInflationSourceText,
    defaultHealthcareInflationSourceUrl,
  } = client.clientAdvisorSettings;

  const inflationSourceText = !isNullOrUndefined(
    defaultHealthcareInflationPercent,
  ) ? (
    <a
      href={
        defaultHealthcareInflationSourceUrl
          ? defaultHealthcareInflationSourceUrl
          : undefined
      }
      target="_blank"
      rel="noopener noreferrer"
      className="text-primary-dark hover:text-primary-dark/80"
    >
      {defaultHealthcareInflationSourceText}
    </a>
  ) : (
    <a
      href="https://www.cms.gov/newsroom/press-releases/cms-office-actuary-releases-2022-2031-national-health-expenditure-projections"
      target="_blank"
      rel="noopener noreferrer"
      className="text-primary-dark hover:text-primary-dark/80"
    >
      2023 Center for Medicare & Medicaid Services (CMS) Office of the Actuary,
      National Health Expenditure Projections
    </a>
  );

  return (
    <p data-testid='healthcare-inflation-rate-citation' className={cn('text-xs text-gray-500', className)}>
      Default inflation rate is{' '}
      {formatPercent(defaultHealthcareInflation(client))} annually based on{' '}
      {inflationSourceText}. Editing this may impact accuracy.
    </p>
  );
}
